export default __webpack_public_path__ + "static/media/Item_Condensed_Resin.1cecf64a.png";